// Module
var code = "<div id=ext-gate-template> <div class=ext-gate-bg></div> </div> ";
// Exports
module.exports = code;